module.exports = __webpack_public_path__ + "static/media/pdf-icon-back-of-envelope.602f49d4.png";